<template>
	<div style="height: 100%">
		<cms-column-json :pid="$cid.play.self" tag="page" class="plan" v-if="$route.path === '/plan'">
			<template slot-scope="pageScope">
				<zui-header :borderGrey="true" :navConfigList="navConfigList"></zui-header>
				<PageNavigater></PageNavigater>
				<!--吃得巴适-->
				<div class="one" id="one">
					<div class="flex w100">
						<cms-column-list :pid="$cid.play.chiDeBaShi" tag="div" class="content vivify fadeInBottom">
							<template slot-scope="{ list }">
								<div class="title"></div>
								<div class="chidebashi" v-for="item in list" :key="item.id">
									<h2>{{ item.name }}</h2>
									<p>{{ item.note }}</p>
								</div>
								<div class="more" @click="chiDeBaShiClick">
									<span>去看看</span>
									<img :src="arrowGrey" alt="" v-hoveranimate="'animate__headShake'">
								</div>
							</template>
						</cms-column-list>
						<cms-image :src="pageScope.json.chiDeBaShi.cover" animate="scale"  class="img vivify fadeInRight"
								   v-if="pageScope.json.chiDeBaShi"></cms-image>
					</div>
				</div>
				<!--住得舒适-->
				<div class="two" id="two" :style="{ backgroundImage: 'url(' + pageScope.json.zhudeShuShi.cover + ')' }"
					 v-if="pageScope.json.zhudeShuShi">
					<div class="title"></div>
					<cms-column-list :pid="$cid.play.zhudeShuShi" :limit="10" class="nav clear">
						<template slot-scope="{list}">
							<a class="zhichou vivify fadeInBottom " v-for="item in list" :key="item.id"
							   @click="$openNewWindow('/new/plan/stay?id=' + item.id)">
								<logo :type="wanType[item.code]" width="79px" height="73px"></logo>
								<p class="delay-1000 vivify">{{ item.name }}</p>
								<p class="english delay-1000 vivify">{{ item.title }}</p>
							</a>
						</template>
					</cms-column-list>
				</div>
				<!--玩的安逸-->
				<cms-column-list id="three" :pid="$cid.play.wanDeAnYi" tag="div" class="three">
					<template slot-scope="{ list }">
						<div class="title"></div>
						<div class="img">
							<swiper class="swiper" ref="mySwiper" :options="swiperOption8"  >
								<swiper-slide v-for="(item,index) in list" :key="item.id"   class="vivify" :id="item.id" :class="[index%2==1?'fadeInTop':'fadeInBottom','delay-'+index*500]">
									<div class="bg"  :itemid="item.id">
										<!-- <cms-image :src="item.cover" class="img-card">
											<div class="mask">
												<img :src="add" alt="" />
											</div>
										</cms-image> -->
										<div :style="'background-image:url('+item.cover+')'" class="img-card" :itemid="item.id">
											<div class="mask" :itemid="item.id">
												<img :src="add" alt="" :itemid="item.id" />
											</div>
										</div>
										<div class="name-card-box" :itemid="item.id">
											<div class="en" :itemid="item.id">{{ ens[item.sort] }}</div>
											<div class="name-card" :itemid="item.id">
												<p :itemid="item.id">{{ item.sort }}</p>
												<p class="name" :itemid="item.id">{{ item.name }}</p>
											</div>
										</div>
									</div>
								</swiper-slide>
								<div class="swiper-button-prev swiper-button-prev8" slot="button-prev">
									<i class="el-icon-arrow-left" style="color: #928050;font-size: 30px;" v-if="isIE"></i>
								</div>
								<div class="swiper-button-next swiper-button-next8" slot="button-next">
									<i class="el-icon-arrow-right" style="color: #928050;font-size: 30px;" v-if="isIE"></i>
								</div>
							</swiper>
						</div>
					</template>
				</cms-column-list>
				<!--购的开心-->
				<cms-column-list id="four" :pid="$cid.play.gouDeKaiXin" tag="div" class="four">
					<template slot-scope="{ list }">
						<div class="title"></div>
						<el-carousel class="carousel" indicator-position="outside" trigger="click" :autoplay="autoplay" ref="carousel">
							<el-carousel-item v-for="item in list" :key="item.id" class="vivify pulsate delay-1000">
								<cms-image :src="item.cover"
										   @click="$openNewWindow('/new/plan/shopping?id=' + item.id)"></cms-image>
							</el-carousel-item>
						</el-carousel>
					</template>
				</cms-column-list>
				<!--节庆活动-->
				<cms-article-list id="five" :pid="$cid.play.jieQingHuoDong" tag="div" class="five">
					<template slot-scope="{ list }">
						<div class="title"></div>
						<swiper class="swiper" :options="swiperOption" @slideChange="onSlideChange" ref="mySwiper">
							<swiper-slide v-for="item in list.slice(0,5)" :key="item.id">
								<!-- <cms-image class="img" @click="$openNewWindow('/new/plan/activity/info?id=' + item.id)" :style="{background: 'url('+item.cover +');'}"></cms-image> -->
								<div class="img" :style="{background: 'url('+item.cover +') no-repeat center', backgroundSize: 'cover', cursor: 'pointer'}" @click="$openNewWindow('/new/plan/activity/info?id=' + item.id)"></div>
								<div class="medium vivify fadeIn"
									 @click="$openNewWindow('/new/plan/activity/info?id=' + item.id)">
									<p>{{ item.title }}</p>
									<div>{{ item.intro }}</div>
									<img :src="arrowBlack" class="more" alt="">
								</div>
							</swiper-slide>

							<div class="swiper-button-next swiper-button-white" slot="button-next">
								<i class="el-icon-arrow-right" style="color: #928050;font-size: 30px;" v-if="isIE"></i>
							</div>
							<div class="swiper-button-prev swiper-button-white" slot="button-prev">
								<i class="el-icon-arrow-left" style="color: #928050;font-size: 30px;" v-if="isIE"></i>
							</div>
						</swiper>
					</template>
				</cms-article-list>
				<zui-footer />
			</template>
		</cms-column-json>
		<router-view v-else></router-view>
	</div>
</template>
<script>
	import './less/plan.css'
	import Logo from '../components/Logo'
	import ZuiButton from '../components/Button'
	import CarouselFlexible from "~/components/CarouselFlexible.vue";
	import icon1 from '../assets/img/icon1.png'
	import arrowGrey from '../assets/img/arrow-grey.png'
	import arrowBlack from '../assets/img/five-arrow.png'
	import add from '../assets/img/add.png'
	import {
		swiper,
		swiperSlide
	} from 'vue-awesome-swiper';
	import 'swiper/css/swiper.css';
	// import Util from '../Util'

	export default {
		components: {
			Logo,
			ZuiButton,
			CarouselFlexible,
			swiper,
			swiperSlide
		},
		data(vm) {
			return {
				swiperOption8: {
					slidesPerView: 5,
					spaceBetween: 0,
					loop:true,
					navigation: {
						nextEl: '.swiper-button-next8',
						prevEl: '.swiper-button-prev8'
					},
					on: {
						click: function (e) {
							// swiper-slide中点击事件获取数据可能在任意一层，所以在每一层都加了 :itemid="item.id" 保证获取到数据
							// 使用获取到的数据进行跳转 注意VM 指向
							console.log(e);//获取到当前点击的内容
							const row = e.target.attributes|| {};
							if(row.itemid.value){
								console.log(row.itemid.value)
								vm.goPage(row.itemid.value);
							}
						}
					},
				},
				swiperOption1: {
					slidesPerView: 3,
					spaceBetween: 30,
					slidesPerGroup: 5,
					loop: true,
					loopFillGroupWithBlank: true,
					navigation: {
						nextEl: '.swiper-button-next1',
						prevEl: '.swiper-button-prev1'
					}
				},
				swiperOption: {
					// autoplay: {
					// 	delay: 5000,
					// 	disableOnInteraction: false,
					// },
					speed: 700,
					allowTouchMove: false,
					lazy: {
						loadPrevNext: true,
						loadPrevNextAmount: 3,
					},
					centeredSlides: true,
					spaceBetween: 40,
					slidesOffsetBefore: 40,
					loop: true,
					slidesPerView: 'auto',
					clickable:true,
					on: {
						slideChangeTransitionEnd: function() {
							this.slides.transition(this.params.autoplay.delay + this.params.speed).transform(
									'translate3d(-45px, 0, 0)');
						},
						slideChangeTransitionStart: function() {
							this.slides.transition(this.params.speed).transform('translate3d(0, 0, 0)');
						},
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					}
				},
				ens: ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN'],
				icon1: icon1,
				arrowGrey: arrowGrey,
				arrowBlack: arrowBlack,
				arrowClass: '',
				add: add,
				wanType: {
					jptj: 'wan1',
					tsms: 'wan3',
					smzs: 'wan2'
				},
				navConfigList: [{
					name: "吃得<br>巴适",
					id: "one",
					height: "616"
				},
					{
						name: "住得<br>舒适",
						id: "two",
						height: "1281"
					},
					{
						name: "玩得<br>安逸",
						id: "three",
						height: "1926"
					},
					{
						name: "购得<br>开心",
						id: "four",
						height: "2365"
					},
					{
						name: "节庆<br>节日",
						id: "five",
						height: "3835"
					},
				],
				isIE: false,
				autoplay: true
			}
		},
		mounted() {
			if(document.getElementsByClassName('zui-page')[0].getAttribute("class").includes("mobileClass")){
				this.swiperOption8.slidesPerView = 3
				this.swiperOption.spaceBetween = 0
			}
			if (document.documentMode) 	this.isIE = true;

			this.slideBanner()

		},
		methods: {

			stopAuto() {
				this.autoplay = false
			},
			startAuto() {
				this.autoplay = true
			},
			// 轮播手滑切换
			slideBanner() {
				let that = this
				setTimeout(() => {
					//选中item的盒子
					var box = document.querySelector('.el-carousel__container')
					if(box){
						//手指起点X坐标
						var startPoint = 0
						//手指滑动重点X坐标
						var stopPoint = 0

						//重置坐标
						var resetPoint = function () {
							startPoint = 0
							stopPoint = 0
						}

						//手指按下
						box.addEventListener('touchstart', function (e) {
							//手指按下的时候停止自动轮播
							that.stopAuto()
							//手指点击位置的X坐标
							startPoint = e.changedTouches[0].pageX
						})
						//手指滑动
						box.addEventListener('touchmove', function (e) {
							//手指滑动后终点位置X的坐标
							stopPoint = e.changedTouches[0].pageX
						})
						//当手指抬起的时候，判断图片滚动离左右的距离
						box.addEventListener('touchend', function () {
							if (stopPoint == 0 || startPoint - stopPoint == 0) {
								resetPoint()
								that.startAuto()
								return
							}
							if (startPoint - stopPoint > 0) {
								resetPoint()
								that.$refs.carousel.next()
								that.startAuto()
								return
							}
							if (startPoint - stopPoint < 0) {
								resetPoint()
								that.$refs.carousel.prev()
								that.startAuto()
								return
							}
						})
					}
				},2000)

			},
			onSlideChange() {
				console.log('slide change');
			},
			chiDeBaShiClick() {
				this.$openNewWindow(`/new/plan/delicious`)
			},
			goPage(id){
				console.log(id)
				this.$openNewWindow('/new/plan/happy?id=' + id)
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/plan.vue